var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationLibIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".applicationLibIco_svg__a{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1220 -52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "applicationLibIco_svg__a",
    width: 28,
    height: 28,
    rx: 2,
    transform: "translate(1220 52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "applicationLibIco_svg__a",
    d: "M1225.25 54.625h21v21h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.875 58.125h-12.25a1.75 1.75 0 00-1.75 1.75v10.5a1.75 1.75 0 001.75 1.75h12.25a1.755 1.755 0 001.75-1.75v-10.5a1.75 1.75 0 00-1.75-1.75zm0 12.25h-12.25v-8.75h12.25z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "applicationLibIco_svg__a",
    d: "M1222.625 56.375h21v21h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.125 61.625h-1.75v12.25a1.755 1.755 0 001.75 1.75h12.25v-1.75h-12.25z"
  })))));
}
export default SvgApplicationLibIco;